import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import SwitchProps from './SwitchProps'


export default {
    template: '<input type="checkbox" />',
    props: SwitchProps,
    mixins: [
        KendoBaseComponent
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoMobileSwitch(that.widgetOptions)

        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', function(){
            that.$emit('changemodel', that.kendoWidget().check())
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoMobileSwitch()
        }
    },
    watch: {
        checked: function (value) {
            var kWidget = this.kendoWidget()

            if(value != kWidget.check()){
                kWidget.check(value)
            }
        }
    },
    model: {
        event: 'changemodel',
        prop: 'checked'
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSwitch/KendoSwitchMixin.js